import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private primaryColor = new BehaviorSubject<string>('');
  private secondaryColor = new BehaviorSubject<string>('');
  private tertiaryColor = new BehaviorSubject<string>('');
  private quaternaryColor = new BehaviorSubject<string>('');

  setPrimaryColor(color: string) {
    this.primaryColor.next(color);
  }

  getPrimaryColor() {
    return this.primaryColor.asObservable();
  }

  setSecondaryColor(color: string) {
    this.secondaryColor.next(color);
  }

  getSecondaryColor() {
    return this.secondaryColor.asObservable();
  }

  setTertiaryColor(color: string) {
    this.tertiaryColor.next(color);
  }

  getTertiaryColor() {
    return this.tertiaryColor.asObservable();
  }

  setQuaternaryColor(color: string) {
    this.quaternaryColor.next(color);
  }

  getQuaternaryColor() {
    return this.quaternaryColor.asObservable();
  }

  constructor() {}
}
